import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';

// Pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import TextAnalysisPage from './pages/analysis/TextAnalysisPage';
import DocumentAnalysisPage from './pages/analysis/DocumentAnalysisPage';
import WebAnalysisPage from './pages/analysis/WebAnalysisPage';
import AnalysisResultPage from './pages/analysis/AnalysisResultPage';
import SectionResultPage from './pages/analysis/SectionResultPage';
import SectionsList from './components/analysis/SectionsList';
import HistoryPage from './pages/history/HistoryPage';
import SettingsPage from './pages/settings/SettingsPage';
import DictionariesPage from './pages/dictionaries/DictionariesPage';
import CorpusPage from './pages/corpus/CorpusPage';
import HelpPage from './pages/help/HelpPage';

// Layout
import AppLayout from './components/layout/AppLayout';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />

        {/* Protected routes */}
        <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route index element={<DashboardPage />} />
          <Route path="analysis/text" element={<TextAnalysisPage />} />
          <Route path="analysis/document" element={<DocumentAnalysisPage />} />
          <Route path="analysis/document/:analysisId/sections" element={<SectionsList />} />
          <Route path="analysis/web" element={<WebAnalysisPage />} />
          <Route path="analysis/web/:analysisId/sections" element={<SectionsList />} />
          <Route path="analysis/:id" element={<AnalysisResultPage />} />
          <Route path="section/:id" element={<SectionResultPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="corpus" element={<CorpusPage />} />
          <Route path="dictionaries" element={<DictionariesPage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

// Protected route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token } = useAuthStore();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

// Public route wrapper (redirect if logged in)
function PublicRoute({ children }: { children: React.ReactNode }) {
  const { token } = useAuthStore();

  if (token) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default App;
